// extracted by mini-css-extract-plugin
export var bodyRow = "_h6-d";
export var cardColumns = "_h6-e";
export var ellipsesOverflow = "_h6-2";
export var flatBottomCorners = "_h6-3";
export var flatTopCorners = "_h6-4";
export var headerActionsDropdown = "_h6-f";
export var headerBottomRow = "_h6-c";
export var headerTopRow = "_h6-b";
export var orderDetailsWrapper = "_h6-0";
export var orderInfoContainer = "_h6-1";
export var productDetails = "_h6-9";
export var productImage = "_h6-5";
export var responsiveTable = "_h6-8";
export var shipmentContainer = "_h6-a";
export var tableBottomLeft = "_h6-6";
export var tableBottomRight = "_h6-7";